const imageVersions = new Map<string, number>()

export function getMapImageVersion(mapId: string) {
  const version = imageVersions.get(mapId) ?? Date.now()
  imageVersions.set(mapId, version)
  return version
}

export function refreshMapImageVersion(mapId: string) {
  const version = Date.now()
  imageVersions.set(mapId, version)
  return version
}
